export default __webpack_public_path__ + "static/streamlining-operations-through-integrated-system-management-b5d8925bc08759732556f9b8e6dbe821.png";